import React, { useState } from "react";
import { Message, MessageProps } from "semantic-ui-react";

type DismissibleMessageProps = {
  header?: string;
  content: string;
} & MessageProps;

const DismissibleMessage = ({ header, content, ...props }: DismissibleMessageProps) => {
  const [visible, setVisible] = useState(true);

  const handleDismiss = () => {
    setVisible(false);
  };

  return visible ? (
    <Message {...props} onDismiss={handleDismiss} header={header} content={content} />
  ) : null;
};

export default DismissibleMessage;
